import React from 'react';
import { services } from '../mock';

const scrollToContact = () => {
  const element = document.getElementById('contacto');
  if (element) {
    const offset = 130;
    const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }
};

const ServicesSection = () => {
  return (
    <section id="servicios" className="py-32 bg-white">
      <div className="container mx-auto px-6 sm:px-12 lg:px-20">
        {/* Section Header */}
        <div className="max-w-3xl mb-20">
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold-700 mb-6">
            Tratamientos
          </p>
          <h2 className="text-4xl sm:text-5xl font-serif font-light text-gray-900 mb-6">
            Nuestros Servicios
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed font-light">
            Tratamientos especializados diseñados para realzar tu belleza natural con las técnicas más avanzadas de la medicina estética.
          </p>
        </div>

        {/* Asymmetrical Editorial Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#E6E4DD]">
          {services.map((service, index) => (
            <div
              key={service.id}
              data-testid={`service-card-${service.id}`}
              className={`group border-b border-r border-[#E6E4DD] p-10 lg:p-12 bg-white hover:bg-[#FAFAF8] transition-colors duration-300 ${
                index === 0 || index === services.length - 1 ? 'lg:col-span-2' : ''
              }`}
            >
              <span className="block text-xs font-serif text-gold-600 mb-6">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="text-2xl lg:text-3xl font-serif font-normal text-gray-900 mb-4 group-hover:text-[#6E4F35] transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed font-light mb-6">
                {service.description}
              </p>
              <button
                onClick={scrollToContact}
                className="text-xs font-medium uppercase tracking-[0.2em] text-[#6E4F35] border-b border-[#6E4F35]/30 pb-1 hover:border-[#6E4F35] transition-colors"
              >
                Reservar Valoración
              </button>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-24 text-center max-w-2xl mx-auto">
          <p className="text-2xl sm:text-3xl font-serif font-light text-gray-800 mb-8 leading-snug">
            La excelencia comienza con un diagnóstico personalizado.
          </p>
          <button
            onClick={scrollToContact}
            data-testid="services-cta-button"
            className="inline-flex items-center px-10 py-4 bg-[#6E4F35] hover:bg-[#5a3f2a] text-cream-100 text-sm font-medium uppercase tracking-[0.15em] transition-colors duration-300"
          >
            Reservar Valoración
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
